// @material-ui/core
import { Grid, Typography } from "@material-ui/core";
import React from "react";

export class ItemCardItemList extends React.Component {
  render() {
    const { title } = this.props;
    const md = this.props.full ? 12 : 6;
    return (
      <Grid item xs={12} md={md}>
        <Typography variant="body2">
          {this.props.list.map((item, index) => {
            return (
              <span key={index}>
                {item}
                <br />
              </span>
            );
          })}
          <small className="muted">{title}</small>
        </Typography>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/library/card/item-card/item-list.js